import { Avatar } from '@dixa/lib-shared-habla';
import { Conversation, LoadDescriptionT } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';
import noop from 'lodash/noop';
import _orderBy from 'lodash/orderBy';

import { getConversationTitle } from 'app/utils/conversationTitle';
import {
  ConversationDetails,
  ConversationDetailsLayout,
} from 'components/conversation/conversationDetails';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';

import ActionsDropdown from '../actionsDropdown/ActionsDropdown';
import { TeamCard } from '../teamCard';

type PropsT = {
  user: User | null;
  csid: LoadDescriptionT['csid'];
  conversation?: LoadDescriptionT['conversation'];
  requester: LoadDescriptionT['requester'];
  channel: LoadDescriptionT['conversation_channel'];
  loadType: LoadDescriptionT['load_type'];
  profileId: string;
  transferToQueueModalOpen: (csid: number) => void;
};

export const TeamConversation = (props: PropsT): JSX.Element | null => {
  const {
    csid,
    conversation,
    requester,
    transferToQueueModalOpen,
    user,
    profileId,
  } = props;

  const conversationTitle = getConversationTitle({
    conversation: conversation as Conversation,
    requester,
  });

  if (!conversation) {
    return null;
  }

  return (
    <TeamCard.Person
      dropdown={
        <ActionsDropdown
          conversation={conversation}
          csid={csid}
          userId={requester && requester.id ? requester.id : null}
          profileId={profileId}
          transferToQueueModalOpen={transferToQueueModalOpen}
        />
      }
      previewDropdownButton={null}
      avatar={<Avatar user={user} />}
      onActionsClick={noop}
    >
      <ConversationDetails
        layout={ConversationDetailsLayout.TeamConversation}
        conversationName={conversationTitle as string}
        metaConversation={metaConversation.from.conversation(
          conversation,
          requester,
        )}
        conversationUrl={`/conversation/${csid}`}
        onTitleClick={() => ampli.teamConversationTitleLinkClicked()}
        onSubTitleClick={() => ampli.teamConversationStatusLinkClicked()}
      />
    </TeamCard.Person>
  );
};
